import React from "react";

import styles from "./Table.module.scss";

export const Table = ({ children }) => {
  return <table style={{ width: "100%" }}>{children}</table>;
};

export const TableHead = ({ className, head, children }) => {
  return (
    <thead className={styles.table_head}>
      <tr className={className}>
        {head.map((list, index) => {
          return <th key={index}>{list}</th>;
        })}
      </tr>
    </thead>
  );
};

export const TableBody = ({ children }) => {
  return <tbody className={styles.table_body}>{children}</tbody>;
};
